<template>
  <div class="container py-5 text-center">
    <h1 class="display-4 mb-3">404 - Página no encontrada</h1>
    <p class="lead mb-4">La página que buscas no existe o ha sido movida.</p>
    <router-link to="/" class="btn btn-primary">Volver al inicio</router-link>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'
export default {
  name: 'NotFoundView',
  setup() {
    useHead({
      title: '404 - Página no encontrada | Medicynia',
      meta: [
        { name: 'robots', content: 'noindex, follow' },
        { name: 'description', content: 'La página que buscas no existe en Medicynia.' }
      ]
    })
  }
}
</script>

<style scoped>
.container {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
